module.exports = __webpack_public_path__ + "static/media/paytm-user.74a266f1.svg";